import { Box, Grid, Link, styled } from "@mui/material";
import { Ico_FolderHeader } from "@sagecentral/core-ui";
import { IProjectHeaderInfo } from "models/projects";
import { useProjectPermissions } from "hooks/projects";
import { useFeatureEnabled } from "hooks/shared";
const HeaderLinkStyled = styled(Link)({
    paddingLeft: '10px',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#0066CC'
});

type ProjectHeaderLinkProps = {
    project: IProjectHeaderInfo
};

const prefixProjectName = (projectName: string) => (`Project: ${projectName}`);
const PrefixProjectNameLink = (props: {name: string, headerUrl: string})=> (
    <>
    <span>Project: </span>
    <HeaderLinkStyled href={props.headerUrl} color="#001A69">{props.name}</HeaderLinkStyled>
    </>
);
const ProjectHeaderLink = (props: ProjectHeaderLinkProps) => {
    const { project } = props;
    const permissions = useProjectPermissions();
    const [ wave4Enabled ] = useFeatureEnabled('wave-4');
    const headerUrl = wave4Enabled 
        ? process.env.REACT_APP_PUBLIC_URL + `/workitems/${project.id}/overview`
        : process.env.REACT_APP_CLASSIC_URL + `/workitemenduser/editworkitem?workitemId=${project.id}`;

    return (
        <Grid 
            xs={11} 
            display="flex" 
            alignItems="center" 
            sx={{
                fontWeight: 600
            }}
        >
            <Box sx={{marginRight:'5px'}}>{Ico_FolderHeader}</Box>
            <PrefixProjectNameLink name={project.name} headerUrl={headerUrl}/>
        </Grid>
    );
};

export default ProjectHeaderLink;